import { FlexLoader } from '@ui/components/FullScreenLoader';
import { PageHeader } from '@ui/components/layout/PageHeader';
import { PageWrapper } from '@ui/components/layout/PageWrapper';

export function SitePageLayoutPlaceholder() {
  return (
    <PageWrapper>
      <PageHeader
        title="Loading site..."
        subtitle="Hang tight"
        bgColor="mw.grey"
        textColor="mw.white"
      />
      <FlexLoader loadingText="Loading site..." />
    </PageWrapper>
  );
}
